import React from "react";
import { StarIcon } from "@heroicons/react/solid";

class Sonderproduktion extends React.Component {
    render() {
        return (
        <div class="bg-gray-light rounded-md p-5 lg:p-10 content-center">
            <StarIcon class="text-red h-10 lg:h-16" />
            <p class="text-2xl text-gray font-medium mt-5 lg:mt-6" >Sonderproduktion</p>
            <p class="text-sm lg:text-base text-gray text-justify mt-2" >Maßgeschneiderte Werbeträger so individuell wie deine Corporate Identity.</p>
            
        </div>
        );
    };
}

export default Sonderproduktion;